import { Session } from 'shared-types';
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import useLayoutStore from './useLayoutStore';

type SessionState = {
  sessionId: string;
  session: Session | undefined;
};

type SessionActions = {
  setSessionId: (sessionId: string) => void;
  setSession: (config: Session) => void;
};

const useSessionStore = create(
  subscribeWithSelector(
    immer<SessionState & SessionActions>((set) => ({
      sessionId: '',
      session: undefined,
      setSessionId: (sessionId: string) => {
        console.log(`[DEBUG] setSessionId: ${sessionId}`);
        set((state) => {
          state.sessionId = sessionId;
        });
      },
      setSession: (session: Session) => {
        console.log('[DEBUG] setSession:', session);
        set((state) => {
          state.session = session;
        });
      },
    })),
  ),
);

// when session is confirmed, we should hide the confirmation button
useSessionStore.subscribe(
  (state) => state.session?.confirmation.confirmed,
  (confirmed) => {
    console.log(`[DEBUG] Session confirmation changed: ${confirmed}`);
    if (confirmed) {
      useLayoutStore.getState().setShouldHideConfirmation(true);
    }
  },
);

// Helper functie voor debugging in de console
if (typeof window !== 'undefined') {
  (window as any).debugStores = {
    ...((window as any).debugStores || {}),
    session: {
      getState: () => useSessionStore.getState(),
      subscribe: (callback: (state: SessionState & SessionActions) => void) =>
        useSessionStore.subscribe(callback),
    },
  };
}

export default useSessionStore;
